<script>

    import { createEventDispatcher } from 'svelte'
    import { toast } from 'bulma-toast'
    import { PackageStore, PackagesStore } from '../stores'

    import PackagesService from '../$services/packages.service'

    import InputNumber from '../$components/input.number.svelte'
    import InputText from '../$components/input.text.svelte'
    import Form from '../$components/form.svelte'

    const dispatch = createEventDispatcher()

    let loading = false
    let data = {
        alias: $PackageStore.alias,
        width: $PackageStore.width,
        height: $PackageStore.height,
        length: $PackageStore.length,
        weight: $PackageStore.weight,
        value: $PackageStore.value,
        content: $PackageStore.content,
    }

    async function updatePackage() {

        loading = true
        const resp = await PackagesService.updatePackage($PackageStore._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        PackageStore.set(resp.data)
        PackagesStore.replace(resp.data)

        dispatch('updated', resp.data)
        toast({message: 'Paquete actualizado', type: 'is-success'})
    }

</script>

<Form on:submit={ updatePackage } on:canceled {loading} >
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.alias} label="Alias" icon="address-book" placeholder="Alias" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.width} label="Ancho" icon="ruler-horizontal" min="1" max="150" placeholder="CM" />
        </div>
        <div class="column">
            <InputNumber bind:value={data.height} label="Alto" icon="ruler-vertical" min="1" max="150" placeholder="CM" />
        </div>
        <div class="column">
            <InputNumber bind:value={data.length} label="Largo" icon="ruler" min="1" max="150" placeholder="CM" />
        </div>
        <div class="column">
            <InputNumber bind:value={data.weight} label="Peso" icon="weight" min="1" max="150" placeholder="KG" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.value} min="0" max="99999" label="Valor del contenido" icon="dollar-sign" placeholder="Valor declarado" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.content} label="Contenido" icon="asterisk" placeholder="Contenido" />
        </div>
    </div>
</Form>